import { DefaultTheme, ThemeProps } from 'styled-components';

import { ButtonSize, IButtonProps } from 'packages/kakapo-ui-kit/types/Button';

export const paddings = {
	[ButtonSize.Small]: '6px 14px',
	[ButtonSize.Medium]: '11px 18px',
	[ButtonSize.Large]: '13px 22px',
};

// This allows you to subtract a border size from the padding, to preserve sizes
export const paddingsMinus = (amount: number) => ({
	[ButtonSize.Small]: `calc(6px - ${amount}px) calc(14px - ${amount}px)`,
	[ButtonSize.Medium]: `calc(11px - ${amount}px) calc(18px - ${amount}px)`,
	[ButtonSize.Large]: `calc(13px - ${amount}px) calc(22px - ${amount}px)`,
});

export const fontSizes = {
	[ButtonSize.Small]: '13px',
	[ButtonSize.Medium]: '15px',
	[ButtonSize.Large]: '17px',
};

export const hoverColorFromProps = (props: IButtonProps & ThemeProps<DefaultTheme>) => {
	if (props.color === 'green') {
		return props.theme.colors.greenDark;
	}

	if (props.color === 'lightBlueLight') {
		return props.theme.colors.lightBlue;
	}

	return props.theme.colors.primaryDark;
};

export const colorFromProps = (props: IButtonProps & ThemeProps<DefaultTheme>) => {
	if (props.color === 'lightBlueLight') {
		return props.disabled ? 'rgba(32, 36, 40, 0.6)' : props.theme.colors.antracite;
	}

	return props.disabled ? 'rgba(255,255,255,0.6)' : props.theme.colors.white;
};
